import React, { useState, useEffect } from "react";
import { isEmpty, isNull, isNil } from "lodash";
import axiosWithAuth from "../../helpers/AxiosHelper";
import errorMessage from "../../helpers/errorMessage";
import "./file_upload.css";
import PageHeader from "../common/PageHeader";
import { useAuth } from "../../hooks/useAuth";
import { FileUpload as FileUploader } from 'primereact/fileupload';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

let data_types = [
  { id: 1, name: 'SME Loans', value: 'SME' },
  { id: 2, name: 'Consumer Loans', value: 'CONSUMER' },
  { id: 3, name: 'ECS Portfolio', value: 'ECS' },
  { id: 4, name: 'Cash Flows', value: 'CASH_FLOWS' },
  { id: 5, name: 'Opportunities', value: 'OPPORTUNITIES' },
  { id: 6, name: 'Loan Applications', value: 'APPLICATIONS' },
  { id: 7, name: 'Invoices', value: 'INVOICE_FINANCING' },
  { id: 8, name: 'Investor Slice', value: 'INVESTOR_SLICE'}
]

let max_file_size = 400000000

// let upload_platforms = [
//   { id: 1, name: 'Acredius', value: 'Acredius' },
//   { id: 2, name: 'Bondster', value: 'Bondster' },
//   { id: 3, name: 'Colectual', value: 'Colectual' },
//   { id: 4, name: 'Conda', value: 'Conda' },
//   { id: 5, name: 'Creditshelf', value: 'Creditshelf' },
//   { id: 6, name: 'Demo', value: 'Demo' },
//   { id: 7, name: 'evenfi', value: 'evenfi' },
//   { id: 8, name: 'FinBee', value: 'FinBee' },
//   { id: 9, name: 'Finomark', value: 'Finomark' },
//   { id: 10, name: 'Geldvoorelkaar', value: 'Geldvoorelkaar' },
//   { id: 11, name: 'Gobifinance', value: 'Gobifinance' },
//   { id: 12, name: 'GoParity', value: 'GoParity' },
//   { id: 13, name: 'HiveFinance', value: 'HiveFinance' },
//   { id: 14, name: 'ITF_Group', value: 'ITF_Group' },
//   { id: 15, name: 'KaapitalOpMaat', value: 'KaapitalOpMaat' },
//   { id: 16, name: 'Kameo', value: 'Kameo' },
//   { id: 17, name: 'Lend', value: 'Lend' },
//   { id: 18, name: 'Lendwise', value: 'Lendwise' },
//   { id: 19, name: 'Rendauto', value: 'Rendauto' },
//   { id: 20, name: 'swisspeers', value: 'swisspeers' },
//   { id: 21, name: 'Untapped Global', value: 'Untapped Global' },
//   { id: 21, name: 'glancecapital', value: 'glancecapital' },
//   { id: 22, name: 'Exalender', value: 'Exalender' }
// ]

const FileUpload = (props) => {

  const { platform, platform_config } = useAuth();
  // const [file_to_upload, setFileUpload] = useState(null);
  const [data_type, setDataType] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [upload_platform, setUploadPlatform] = useState('');
  const [data_types_select, setDataTypesSelect] = useState(data_types.filter(obj => checkDataTypes(obj)));
  const [platforms_list, setPlatformsList] = useState([])
  const [invoice_allocations, setInvoiceAllocations] = useState([]);
  const [allocation_id, setAllocationId] = useState('');
  // const [file, setFile] = useState();

  // onFileChange = event => {
  //   this.setState({ file_to_upload: event.target.files[0] });
  //   // this.props.setLoading(true);
  // };
  // upload_platforms = [
  //   { id: 1, name: 'Acredius', value: 'Acredius' },
  //   { id: 2, name: 'Bondster', value: 'Bondster' },
  //   { id: 3, name: 'Colectual', value: 'Colectual' },
  //   { id: 4, name: 'Conda', value: 'Conda' },
  //   { id: 5, name: 'Creditshelf', value: 'Creditshelf' },
  //   { id: 6, name: 'Demo', value: 'Demo' },
  //   { id: 7, name: 'evenfi', value: 'evenfi' },
  //   { id: 8, name: 'FinBee', value: 'FinBee' },
  //   { id: 9, name: 'Finomark', value: 'Finomark' },
  //   { id: 10, name: 'Geldvoorelkaar', value: 'Geldvoorelkaar' },
  //   { id: 11, name: 'Gobifinance', value: 'Gobifinance' },
  //   { id: 12, name: 'GoParity', value: 'GoParity' },
  //   { id: 13, name: 'HiveFinance', value: 'HiveFinance' },
  //   { id: 14, name: 'ITF_Group', value: 'ITF_Group' },
  //   { id: 15, name: 'KaapitalOpMaat', value: 'KaapitalOpMaat' },
  //   { id: 16, name: 'Kameo', value: 'Kameo' },
  //   { id: 17, name: 'Lend', value: 'Lend' },
  //   { id: 18, name: 'Lendwise', value: 'Lendwise' },
  //   { id: 19, name: 'Rendauto', value: 'Rendauto' },
  //   { id: 20, name: 'swisspeers', value: 'swisspeers' },
  //   { id: 21, name: 'Untapped Global', value: 'Untapped Global' },
  //   { id: 21, name: 'glancecapital', value: 'glancecapital' },
  //   { id: 21, name: 'Vauraus', value: 'Vauraus' }
  // ]

  useEffect(() => {
    props.setLoading(true);
    axiosWithAuth.get("/platforms")
      .then(data => {
        // console.log('Inside config')
        // console.log(data)
        setPlatformsList(data.data)
      }).catch(err => {
        setError(errorMessage(err));
      }).finally(() => {
        props.setLoading(false);
      });
  }, []);
 
  const is_cash_flows = data_type === 'CASH_FLOWS';
  const is_invoice = data_type === 'INVOICE_FINANCING';

  // Invoice uploads go to one of the LoanSweeper allocations an admin
  // configured for the platform (Platforms > platform > Invoice allocations).
  useEffect(() => {
    setInvoiceAllocations([]);
    setAllocationId('');
    if (!is_invoice) return;
    const applyAllocations = (list) => {
      setInvoiceAllocations(list);
      setAllocationId(list.length === 1 ? list[0].allocation_id : '');
    };
    if (platform === "Exaloan") {
      applyAllocations(platforms_list.find(p => p.platform === upload_platform)?.invoice_allocations || []);
    } else {
      axiosWithAuth.get("/platforms/config", { params: { platform } })
        .then(res => applyAllocations(res.data?.[0]?.invoice_allocations || []))
        .catch(err => setError(errorMessage(err)));
    }
  }, [is_invoice, platform, upload_platform, platforms_list]);

  const onFileUpload = (event) => {
    // event.preventDefault();
    let filesToUpload = event.files
    setError('')
    if (!fileValidation(filesToUpload)) {
      setError('File size is too big. Cannot upload more than 200MB');
      return;
    }
    if (isNull(data_type) || isEmpty(data_type)) {
      setError('File type cannot be null.')
      return;
    }
    if (filesToUpload.length > 1 && !is_cash_flows) {
      setError('Please upload one file.')
      return;
    }

    let selected_platform = platform
    if (platform === "Exaloan") {
      if (isNull(upload_platform) || isEmpty(upload_platform)) {
        setError('upload_platform cannot be null.')
        return;
      }
      selected_platform = upload_platform
    };
    if (is_invoice) {
      if (invoice_allocations.length === 0) {
        setError(`No invoice allocations are configured for ${selected_platform}. Please contact the Exaloan team.`)
        return;
      }
      if (isEmpty(allocation_id)) {
        setError('Please choose which allocation these invoices are for.')
        return;
      }
    }

    if (is_cash_flows && filesToUpload.length > 1) {
      confirmDialog({
        header: 'Uploading multiple cash flow files',
        icon: 'pi pi-exclamation-triangle',
        message: 'This feature is intended for separate cash flow files (actual and planned). If you are uploading multiple cash flow files for the first time, please inform the Exaloan team, otherwise your files might not be processed.',
        acceptLabel: 'Upload',
        rejectLabel: 'Cancel',
        accept: () => sendFiles(event, selected_platform)
      });
      return;
    }
    sendFiles(event, selected_platform);
  };

  const sendFiles = (event, selected_platform) => {
    let filesToUpload = event.files
    const formData = new FormData();

    filesToUpload.forEach(element => {
      formData.append("uploadedFiles", element)
    });
    formData.append("platform", selected_platform)
    formData.append("data_type", data_type)
    formData.append("upload_type", "platform_data")
    if (is_invoice) {
      formData.append("allocation_id", allocation_id)
    }

    props.setLoading(true);

    axiosWithAuth.post('/files', formData).then(() => {
      let msg = `File ${filesToUpload.map(file => file.name)} has been successfully uploaded`
      setSuccess(msg);
    }).catch((err) => {
      setError(errorMessage(err));
    }).finally(() => {
      // file.value = null;
      // let file_temp = file;
      // file_temp.value = null;
      // setFile(file_temp);
      event.options.clear();
      setDataType('');
      setUploadPlatform('');
      props.setLoading(false);

    });
  };

  const fileValidation = (files) => {
    let file_size = 0
    for (let file of files){
      file_size += file.size
    }
    if (file_size > max_file_size)
      return false;
    return true;
  }

  function checkDataTypes(obj) {
    if (!isNil(platform_config?.data_types)) {
      return platform_config.data_types.includes(obj.value) || obj.id === 0;
    } else {
      return obj.id === 0;
    }
  }

  // data_types_select used to only be computed once, at mount, via
  // useState's initializer - it never reacted to platform_config/platform
  // changing afterward (e.g. an admin's "View As" switching platforms
  // without a full remount, or a platform's own config being edited
  // mid-session). Exaloan admins additionally upload on behalf of another
  // platform, so their data-type options come from the selected platform's
  // own config (in platforms_list) rather than Exaloan's own.
  useEffect(() => {
    if (platform === "Exaloan") {
      let selected_platform_config = platforms_list.find(p => p.platform === upload_platform);
      let allowed_data_types = selected_platform_config?.data_types || [];
      setDataTypesSelect(data_types.filter(obj => allowed_data_types.includes(obj.value)));
    } else {
      setDataTypesSelect(data_types.filter(obj => checkDataTypes(obj)));
    }
    setDataType('');
  }, [platform, upload_platform, platforms_list, platform_config]);

  const chooseOptions = { label: 'Browse', icon: 'pi pi-fw pi-plus' };
  const emptyTemplate = () => {
    return (
      <div className="upload-dropzone">
        <span className="upload-dropzone-icon"><i className="pi pi-cloud-upload" /></span>
        <span className="upload-dropzone-title">Drag and Drop File Here</span>
        <span className="upload-dropzone-hint">or use Browse above to pick files from your computer</span>
        <div className="upload-dropzone-meta">
          <small>Maximum file size: {max_file_size / (1000 * 1000)}MB.</small>
          <small>We accept .xlsx, .xls, .csv, .json files</small>
        </div>
      </div>
    )
  }

  const needs_platform = platform === "Exaloan";

  return (
    <>
      <div className="upload">
        <PageHeader
          icon="pi-cloud-upload"
          title="File Upload"
          subtitle={<>Check the <a href="/filetracking">File Tracking</a> page for information about your uploaded files.</>}
        />
        {error && <div name='error' className="errorMsg upload-alert">{error}</div>}
        {success && <div name='success' className="successMsg upload-alert">{success}</div>}
        <div className="upload-layout">
          <div className="upload-steps p-fluid">
            <section className="upload-step">
              <header className="upload-step-header">
                <span className="upload-step-number">1</span>
                <div>
                  <h3 className="upload-step-title">What are you uploading?</h3>
                  <div className="upload-step-subtitle">{needs_platform ? "Pick the Originator and the type of data in the file." : "Pick the type of data in the file."}</div>
                </div>
              </header>
              <div className="grid">
                {needs_platform && <div className="field col-12 md:col-6">
                  <span className="p-float-label upload-form-items">
                    <Dropdown inputId="uploadPlatform" value={upload_platform} optionLabel="platform" optionValue='platform' onChange={(e) => setUploadPlatform(e.value)} options={platforms_list} />
                    <label htmlFor="uploadPlatform">Originator to Upload for</label>
                  </span>
                  <small id="uploadPlatform-help" >Select the Originator that you are uploading for.</small>
                </div>}
                <div className={`field col-12${needs_platform ? " md:col-6" : ""}`}>
                  <span className="p-float-label upload-form-items">
                    <Dropdown inputId="dataType" value={data_type} optionLabel="name" optionValue='value' onChange={(e) => setDataType(e.value)} options={data_types_select} disabled={platform === "Exaloan" && isEmpty(upload_platform)} />
                    <label htmlFor="dataType">Data Type</label>
                  </span>
                  <small id="dataType-help" >{(platform === "Exaloan" && isEmpty(upload_platform)) ? "Select an Originator above first." : "Select the type of data being uploaded."}</small>
                </div>
                {is_invoice && <div className="field col-12 md:col-6">
                  <span className="p-float-label upload-form-items">
                    <Dropdown inputId="allocation" value={allocation_id} optionLabel="name" optionValue="allocation_id" onChange={(e) => setAllocationId(e.value)} options={invoice_allocations} disabled={invoice_allocations.length <= 1} />
                    <label htmlFor="allocation">Allocation</label>
                  </span>
                  {invoice_allocations.length === 0
                    ? <small id="allocation-help" className="p-error">No invoice allocations are configured for this Originator. Please contact the Exaloan team.</small>
                    : <small id="allocation-help">{invoice_allocations.length === 1 ? "The only allocation set up for these invoices." : "Select which allocation these invoices are for."}</small>}
                </div>}
              </div>
            </section>

            <section className="upload-step">
              <header className="upload-step-header">
                <span className="upload-step-number">2</span>
                <div>
                  <h3 className="upload-step-title">Add your files</h3>
                  <div className="upload-step-subtitle">{is_cash_flows ? "Browse or drop one or more files, then press Upload." : "Browse or drop a file, then press Upload."}</div>
                </div>
              </header>
              <FileUploader name='loanbook' accept=".xlsx, .xls, .csv, .json" maxFileSize={max_file_size} chooseOptions={chooseOptions} multiple={is_cash_flows} emptyTemplate={emptyTemplate} customUpload uploadHandler={onFileUpload} />
              <ConfirmDialog />
            </section>
          </div>

          <aside className="upload-aside">
            <h4 className="upload-aside-title">Before you upload</h4>
            <ul className="upload-aside-list">
              <li><i className="pi pi-file-excel" /><span>Excel (.xlsx, .xls), CSV or JSON files</span></li>
              <li><i className="pi pi-database" /><span>Up to {max_file_size / (1000 * 1000)}MB in total per upload</span></li>
              <li><i className="pi pi-book" /><span>Templates and information sheets are under <strong>User Guide</strong> in the top bar</span></li>
              <li><i className="pi pi-history" /><span>Processing status appears in <a href="/filetracking">File Tracking</a></span></li>
            </ul>
          </aside>
        </div>

        {/* <Box sx={{ minWidth: 120 }}>
          <FormControl>
          <Input labelId="browse-file-label" name='loanbook' id="file" accept= ".xlsx, .xls, .csv, .json" type="file" onChange={onFileChange}/>
          <InputLabel id="select-file-type-label">Loan Type</InputLabel>
            <Select
            labelId="select-file-type-label"
            id="select-file-type"
            value={file_type}
            >Loan Type
              {data_types.map(file => (
                <MenuItem 
                key={file.id}
                value={file.value}
                label="Loan Type"

                >{file.name}
                </MenuItem>
              ))}
            </Select>  
        </FormControl>
        </Box> */}
      </div>
    </>
  );
};
export default FileUpload;
// div style={{width:"100%",position:"relative"}}